const actions = {
    GET_ALL_PAYMENTS: "tariff/GET_ALL_PAYMENTS",
    SET_ALL_PAYMENTS: "tariff/SET_ALL_PAYMENTS",
    // Stany zadania - bez nich brak danych i blad wygladaly jak wieczne wczytywanie
    SET_ALL_PAYMENTS_LOADING: "tariff/SET_ALL_PAYMENTS_LOADING",
    SET_ALL_PAYMENTS_ERROR: "tariff/SET_ALL_PAYMENTS_ERROR",

    GET_PAYMENT_STATUSES: "tariff/GET_PAYMENT_STATUSES",
    SET_PAYMENT_STATUSES: "tariff/SET_PAYMENT_STATUSES",
};

export default actions;
